import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ob-gpm',
  templateUrl: './ob-gpm.component.html',
  styleUrls: ['./ob-gpm.component.scss']
})
export class ObGpmComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
